// utils/liveTournamentIds.ts
//
// Shared "live tournament id set" reader used by orphan filters (dashboards via
// useTournamentMetadata, the job board, etc.). The orphan check only needs the
// SET OF IDS, not the (multi-MB) /tournaments tree — but the JS SDK get() has no
// shallow option, so read keys only via the REST shallow=true endpoint. Returns
// null (meaning "couldn't read — don't filter") if the URL/token/network is
// unavailable, so an auxiliary read can never hard-fail a caller.

import { app, auth } from '../config/firebase';

export async function fetchLiveTournamentIds(): Promise<Set<string> | null> {
  const base = app.options.databaseURL;
  if (!base) return null;
  try {
    const token = await auth.currentUser?.getIdToken().catch(() => null);
    const url =
      `${base.replace(/\/+$/, '')}/tournaments.json?shallow=true` +
      (token ? `&auth=${encodeURIComponent(token)}` : '');
    const res = await fetch(url);
    if (!res.ok) return null;
    const data = (await res.json()) as Record<string, true> | null;
    return data ? new Set(Object.keys(data)) : new Set<string>();
  } catch {
    return null;
  }
}
